<template>
  <div class="sub-com-wrap">
    <div class="title">
      <div class="sep"></div>
      添加办税人员
    </div>

    <div class="content">
      <div class="form-wrap">
        <el-form :model="formData" class="add-form"
                 size="large"
                 ref="formRef" :rules="rules" :inline="false" label-width="100px">

          <el-form-item
              label="姓名"
              prop="ticName">
            <el-input
                v-model="formData.ticName"
                placeholder="请输入"/>
          </el-form-item>

          <el-form-item
              label="证件类型"
              prop="idType">
            <el-select
                v-model="formData.idType"
                placeholder="请选择"
                clearable
            >
              <el-option label="居民身份证" value="居民身份证"/>
            </el-select>
          </el-form-item>

          <el-form-item
              label="证件号码"
              prop="idNumber">
            <el-input
                v-model="formData.idNumber"
                placeholder="请输入"/>
          </el-form-item>

          <el-form-item
              label="身份类型"
              prop="roleType">
            <el-select
                v-model="formData.roleType"
                placeholder="请选择"
                clearable
            >
              <el-option label="办税员" value="办税员"/>
              <el-option label="开票员" value="开票员"/>
              <el-option label="管理员" value="管理员"/>
            </el-select>
          </el-form-item>

          <el-form-item
              label="人员权限"
              style="position: relative;"
              prop="personPermission">
            <el-input
                readonly
                v-model="formData.personPermission"
                placeholder=""/>
            <el-link
                type="primary"
                :underline="false"
                style="position: absolute;left: 15px;user-select: none;z-index: 10;right: 0;justify-content: flex-start;"
                :style="{opacity: formData.personPermission ? 0 : 1}"
                @click="addTaxUserVis = true"
            >请点击设置人员权限
            </el-link>
          </el-form-item>

          <el-form-item
              label="有效期止"
              prop="validTime">
            <el-select
                v-model="formData.validTime"
                placeholder="请选择"
                clearable
            >
              <el-option label="长期" value="长期"/>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       size="default"
                       @click="submit"
            >确定
            </el-button>
            <el-button
                style="margin-left: 50px;"
                type="info" size="default"
                @click="reset"
            >重置
            </el-button>
          </el-form-item>

        </el-form>
      </div>
    </div>

    <add-tax-user-choose-per-dialog
        v-model:visible="addTaxUserVis"
        :initial-check-list="formData.personPermission"
        @confirm="val => formData.personPermission = val"
    />
  </div>
</template>

<script setup>
import AddTaxUserChoosePerDialog from "./addTaxUserChoosePerDialog.vue";
import {useTaxUserStore} from "./addTaxPina.js";
import {ElMessage} from "element-plus";
import dayjs from "dayjs";

const store = useTaxUserStore()
const {userAnswer} = storeToRefs(store);

const formData = ref({})
const addTaxUserVis = ref(false)
const formRef = ref()

const rules = reactive({
  ticName: {required: true, message: '请输入', trigger: ['blur', 'change']},
  idType: {required: true, message: '请选择', trigger: ['blur', 'change']},
  idNumber: {required: true, message: '请输入', trigger: ['blur', 'change']},
  roleType: {required: true, message: '请选择', trigger: ['blur', 'change']},
  personPermission: {required: true, message: '请选择', trigger: ['blur', 'change']},
  validTime: {required: true, message: '请选择', trigger: ['blur', 'change']},
})

function reset() {
  formRef.value.resetFields();
}

async function submit() {
  await formRef.value.validate(valid => {
    if (valid) {
      if (userAnswer.value.some(s => s.idNumber == formData.value.idNumber)) {
        ElMessage({
          type: 'warning',
          message: '该证件号码人员已添加，请勿重复添加!',
          duration: 4000,
        })
        return
      }
      userAnswer.value.push({
        ...formData.value,
        createTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
      })
      ElMessage.success('添加成功')
      reset()
    }
  })
}
</script>


<style scoped lang="scss">
.sub-com-wrap {
  height: 100%;
  background-color: #FFFFFF;
  box-sizing: border-box;
  padding: 18px 20px;

  .title {
    font-size: 20px;
    line-height: 30px;
    color: #303133;
    font-weight: 700;
    display: flex;
    align-items: center;

    .sep {
      width: 5px;
      background-color: #409eff;
      margin-right: 8px;
      height: 20px;
      border-radius: 20%;
    }
  }

  .content {
    margin-top: 20vh;

    .form-wrap {
      width: 450px;
      margin: auto;
    }
  }
}
</style>
